import { render, staticRenderFns } from "./swiper-btn-wrap-secondary.vue?vue&type=template&id=54d910f7&scoped=true&"
import script from "./swiper-btn-wrap-secondary.vue?vue&type=script&lang=js&"
export * from "./swiper-btn-wrap-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d910f7",
  null
  
)

export default component.exports